import Vue from 'vue'
import Router from 'vue-router'
import Home from '../views/Home.vue'
import StopsList from '../views/StopsList.vue'
import Stop from '../views/Stop.vue'
import StopMap from '../views/StopMap.vue'
import Info from '../views/Info.vue'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  scrollBehavior() {
    return {
      x: 0,
      y: 0
    };
  },
  routes: [{
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/stops',
      name: 'stops',
      component: StopsList
    },
    {
      path: '/map',
      name: 'map',
      component: StopMap
    },
    {
      path: '/info',
      name: 'info',
      component: Info
    },
    {
      path: '/stop/:id', // dynamic segment. slug will be a param the component has access to.
      name: 'stop',
      component: Stop,
      props: true // send params as props.
    },
    // { path: '*', component: Home },
    // { path: '*/*', component: Home },
  ]
})